import { useState } from 'react'
import { format, addMonths } from 'date-fns'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../../Icons'

const CardSummaryItem = ({ customCardValue, cardValue, expDate, card, type, isService }) => {
  const { t } = useTranslation(['rewards-gift', 'rewards-table'])
  const valueToDisplay = customCardValue ?? cardValue

  const [now] = useState(() => Date.now())

  return (
    <div>
      <span className="card-summary-title">
        {type === 'link'
          ? t('rewards-gift:cardSummaryItem.giftSummary')
          : t('rewards-gift:cardSummaryItem.cardSummary')}
      </span>
      <div className="card-summary-item">
        {type === 'custom' && (
          <div className="card-summary-item__image-container">
            <img
              className="card-summary-item__image"
              src={card.cardImageUrl}
              onError={(e) => (e.target.style.display = 'none')}
            />
            <div className="card-summary-item__image-container__text">
              <span>{card.name}</span>
              <span>${valueToDisplay}</span>
            </div>
          </div>
        )}
        {type === 'external' && (
          <img className="card-summary-item__image" src={card.logoImageUrl} />
        )}
        {type === 'link' && (
          <div className="card-summary-item__image-container">
            <div className="card-summary-item__image-container__text link">
              <Icon icon="moneyBag" />
              <span>{t('rewards-gift:cardSummaryItem.over300GiftCardsAvailable')}</span>
            </div>
          </div>
        )}
        <div className="card-summary-item__table">
          <span>
            {type === 'link' ? t('rewards-gift:selectGiftType.cashRewardLink') : card.name}
          </span>
          <table>
            <thead>
              <tr>
                <th>{t('rewards-gift:cardSummaryItem.cardValue')}</th>
                {card && type === 'external' && <th>{t('rewards-gift:cardSummaryItem.cardId')}</th>}
                {isService && <th>{t('rewards-gift:cardSummaryItem.cost')}</th>}
                {((card && card.expiryInMonths) || expDate) && (
                  <th>{t('rewards-table:csvFields.expirationDate')}</th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${valueToDisplay}</td>
                {card && type === 'external' && <td>{card.code}</td>}
                {isService && (
                  <td className="discount-label">
                    <div>
                      ${Math.ceil(valueToDisplay - valueToDisplay * 0.1)}{' '}
                      <span>{t('rewards-gift:cardSummaryItem.tenPercentOff')}</span>
                    </div>
                  </td>
                )}
                {card && type === 'external' ? (
                  card.expiryInMonths && (
                    <td>{format(addMonths(now, card.expiryInMonths), 'MM/dd/yyyy')}</td>
                  )
                ) : (
                  <td>{format(expDate, 'MM/dd/yyyy')}</td>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

CardSummaryItem.propTypes = {
  cardImageUrl: PropTypes.string,
  cardName: PropTypes.string,
  cardValue: PropTypes.string,
  customCardValue: PropTypes.string,
  expDate: PropTypes.Date,
  card: PropTypes.object,
  isService: PropTypes.bool,
  type: PropTypes.oneOf(['custom', 'external', 'link']),
}

export default CardSummaryItem
